'use strict';

/*
 * Default configuration
 *
 * Valid values for resource_channel attribute:
 *  RESOURCE_PUBLIC,
 *  RESOURCE_EXCLUSIVE
 *  RESOURCE_REFERENCE
 *  CALENDAR_PUBLIC
 */

var primary = {
    el: "#bookingjs",
    name: "",
    autoload: true,
    debug: false,
    disable_remote_load: false,
    disable_confirm_page: false,
    resource_channel: "RESOURCE_REFERENCE",
    create_booking_response_include: ["attributes", "event", "user"],
    ui: {
        display_name: "",
        show_credits: true,
        show_timezone_helper: false,
        availability_view: "agendaWeek",
        avatar: "",
        time_date_format: "24h-dmy-mon", /*"12h-mdy-sun"*/
        localization: {
            allocated_product_prefix: "mit",
            allocated_resource_prefix: "in",
            product_selection_headline: "Terminart wählen",
            submit_button: "Buchen",
            success_message: "Ihre Termin-Buchung wurde erfasst. Sie erhalten eine E-Mail mit den Termindetails an %s",
        }
    },
    availability: {
        mode: "roundrobin_random"
    },
    booking: {
        graph: "instant"
    },
    customer_fields: {
        firstName: {
            title: "Vorname",
            required: true
        },
        lastName: {
            title: "Nachname",
            required: true
        },
        email: {
            title: "E-mail",
            format: "email",
            required: true
        },
        mobile: {
            title: "Mobil",
            format: "",
            required: true
        },
        message: {
            title: "Ihre Nachricht",
            prefilled: "",
            format:"textarea",
            required: false
        },
    },
    callbacks: {},
    sdk: {
        headers: {
            "Timum-Context": "widget"
        }
    },
    fullcalendar: {
        views: {
            agenda: {
                displayEventEnd: false
            },
            listing: {
                type: "list",
                duration: { days: 365 / 2 },
                listDayAltFormat: "dddd",
                noEventsMessage: "Zur Zeit sind leider keine buchbaren Termine verfügbar."
            }
        },
        /* height: 500, */
        contentHeight: 400,
        minTime: '08:00:00',
        maxTime: '21:00:00',
        locale: "de",
        allDaySlot: false,
        /*scrollTime: "08:00:00", */  /*prefer fullcalendar automatism */
        nowIndicator: true
    }
};

var customerFieldsNativeFormats = {
    email: {
        format: "email"
    },
    comment: {
        format: "textarea"
    },
    phone: {
        format: "tel"
    }
};

// Preset: timeDateFormat = '24h-dmy-mon'
var timeDateFormat24hdmymon = {
    ui: {
        booking_date_format: "D. MMMM YYYY",
        booking_time_format: "HH:mm"
    },
    fullcalendar: {
        timeFormat: "HH:mm",
        firstDay: 1,
        views: {
            basic: {
                columnFormat: "dddd D.M."
            },
            agenda: {
                columnFormat: "ddd D.M.",
                slotLabelFormat: "HH:mm"
            }
        }
    }
};

// Preset: timeDateFormat = '12h-mdy-sun'
var timeDateFormat12hmdysun = {
    ui: {
        booking_date_format: "MMMM D, YYYY",
        booking_time_format: "h:mma"
    },
    fullcalendar: {
        timeFormat: "h:mma",
        firstDay: 0,
        views: {
            basic: {
                columnFormat: "dddd M/D"
            },
            agenda: {
                columnFormat: "ddd M/D",
                slotLabelFormat: "h:mma"
            }
        }
    }
};

// Preset: availabilityView = 'agendaWeek'
var availabilityViewAgendaWeek = {
    fullcalendar: {
        header: {
            left: "",
            center: "",
            right: "today, prev, next"
        },
        defaultView: "agendaWeek"
    }
};

// Preset: availabilityView = 'listing'
var availabilityViewListing = {
    fullcalendar: {
        header: {
            left: "",
            center: "",
            right: ""
        },
        defaultView: "listing"
    }
};

// Export objects
module.exports = {
    primary: primary,
    customerFieldsNativeFormats: customerFieldsNativeFormats,
    presets: {
        timeDateFormat: {
            "24h-dmy-mon": timeDateFormat24hdmymon,
            "12h-mdy-sun": timeDateFormat12hmdysun
        },
        availabilityView: {
            agendaWeek: availabilityViewAgendaWeek,
            listing: availabilityViewListing
        }
    }
};
